let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h1t7D")).then(() => parcelRequire('aK7PB'));